<template>
<div id="content">
<!-- ページ内ヘッダ -->
	<div class="center">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li class="selected">基本情報</li>
			<li>連絡先</li>
			<li>その他</li>
			<li>内容確認</li>
		</ul>
	</div>
<!-- 内容 -->
	<div id="mosikomi" class="content-blk">
		<Form v-slot="{ errors }" @submit="onSubmit">
			<!-- ステップ１：基本情報 -->
			<div class="inner">
				<dl>
					<dt class="necessary detail_title">ログインID</dt>
					<dd><Field type="text" name="loginid" v-model="katudo.id" :rules="isLogInfo" /></dd>
					<dd class="hinttext">（半角英数字10文字以内）</dd>
					<dd class="error">{{ errors.loginid }}</dd>
					<dd class="error">{{ loginid_error }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">パスワード</dt>
					<dd><Field type="password" name="password" v-model="katudo.password" :rules="isLogInfo" autocomplete="new-password" /></dd>
					<dd class="hinttext">（半角英数字10文字以内）</dd>
					<dd class="error">{{ errors.password }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">パスワード（確認）</dt>
					<dd><Field type="password" name="passconf" rules="isPass:@password" /></dd>
					<dd class="hinttext">（確認のため、同じパスワードを入力してください）</dd>
					<dd class="error">{{ errors.passconf }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">氏名</dt>
					<dd><Field type="text" name="katudoname" v-model="katudo.name" :rules="isName" /></dd>
					<dd class="hinttext">（25文字以内/例：【青森 太郎】）</dd>
					<dd class="error">{{ errors.katudoname }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">氏名（ふりがな）</dt>
					<dd><Field type="text" name="katudokana" v-model="katudo.kana" :rules="isName" /></dd>
					<dd class="hinttext">（25文字以内/例：【あおもり たろう】）</dd>
					<dd class="error">{{ errors.katudokana }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">性別</dt>
					<dd class="flex">
						<div><Field type="radio" name="seibetu" value="2" v-model="katudo.sex" :rules="isRequired" id="man" /><label for="man">男性</label></div>
						<div><Field type="radio" name="seibetu" value="1" v-model="katudo.sex" :rules="isRequired" id="woman" /><label for="woman">女性</label></div>
					</dd>
					<dd class="error">{{ errors.seibetu }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">生年月日</dt>
					<dd>
						<DatePicker v-model="birth" class="input_birth" color="teal" :masks="masks">
							<template v-slot="{ inputValue, inputEvents, togglePopover}">
								<input :value="inputValue" v-on="inputEvents">
								<button class="icon-calendar" @click="togglePopover" type="button"><fa :icon="['far','calendar-alt']" class="icon fa-2x" /></button>
							</template>
						</DatePicker>
						<!-- <input type="date" v-model="katudo.birth"> -->
						<Field class="hideObject" name="birthday" v-model="katudo.birth" :rules="isRequired" /></dd>
					<dd class="hinttext">（半角数字で入力、またはカレンダーより選択してください）<br>※ カレンダーの西暦を押すと、年度を選ぶことができます。</dd>
					<dd class="error">{{ errors.birthday }}</dd>
				</dl>
			</div>
	<div class="button_rev justifycont-c">
		<button type="submit" class="btn_on order2">次へ</button>
		<router-link to="/katudo-touroku/first" class="order1"><button class="btn_cancel">戻る</button></router-link>
		<!-- <router-link to="/katudo-touroku/step2"><button type="submit">次へ</button></router-link> -->
	</div>
	<p v-if="Object.keys(errors).length" class="error" style="text-align: center;">未入力もしくはエラー項目があります。ご確認ください。</p>
	<p class="error" style="text-align: center;">{{ loginid_error }}</p>
		</Form>
	</div>
</div>
</template>

<script>
// 状態管理
import { inject } from 'vue';
import { Field, Form, defineRule } from 'vee-validate';
import router from '../router';
import axios from 'axios';
import { DatePicker } from 'v-calendar';
import { format } from 'date-fns'

// パスワード一致するか否か
defineRule("isPass",(value, [other]) => {
	if (!value || !value.length) {
		return '必須項目です。';
	}
	if (value !== other) {
		return 'パスワードが一致しません。'
	}
	return true;
});

export default {
	name: 'KatsudoTouroku2',
	components: {
		Field,
		Form,
		// Calendar,
		DatePicker,
	},
	setup(){
		const { katudo } = inject('ktouroku');
		return {
			katudo,
		};
	},
	data() {
		return {
			// katudo: {},
			loginid_error: "",
			birth: "",
			birthday: "",
			masks: {
				title: "YYYY年 MMMM"
			}
		};
	},
	created() {
		if(this.katudo.birth){
			this.birth = new Date(this.katudo.birth);
		}
	},
	watch: {
		birth(day) {
			console.log(day)
			if(day) {
				this.katudo.birth = format(day, 'yyyy-MM-dd');
			} else {
				this.katudo.birth = "";
			}
		}
	},
	methods: {
		async onSubmit() {
			try {
				let res = await axios.post('/api/katudosya_data/id_existence',{
					loginid: this.katudo.id
				})
				// console.log(res)
				if (res.data === false) {
					this.loginid_error = "";
					router.push({ path: '/katudo-touroku/step2'});
				} else {
					alert('このログインIDは既に使用されています。\n別のログインIDを入力してください。');
					this.loginid_error = "別のログインIDを入力してください。";
				}
			} catch (e) {
				console.log('error内容')
				console.log(e.response.status);
			}
		},
		// バリデーションルール
		// 必須
		isRequired(value) {
			return (value && value.length) ? true : '必須項目です';
		},
		// 25文字以内（必須）
		isName(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (value.length > 25) {
				return '25文字以内で入力してください。'
			}
			return true;
		},
		// ログインID、パスワード
		isLogInfo(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (!(/^[a-zA-Z0-9]{1,10}$/.test(value))) {
				return '10桁以内の半角英数字を入力してください。'
			}
			return true;
		},
		// // パスワード確認
		// isPass(value, [other]) {
		// 	if (!value || !value.length) {
		// 		return '必須項目です。';
		// 	}
		// 	if (value !== other) {
		// 		return 'パスワードが一致しません。'
		// 	}
		// 	return true;
		// },
	},
}
</script>
